import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes, useNavigate, } from "react-router-dom";
import { Provider, useDispatch } from 'react-redux';
import store from './redux/store';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import "./app.scss"
const stripePromise = loadStripe(process.env.NODE_ENV === 'production' ? "pk_live_51Kw3QQFHklCQeNE23WarXvigDO9oSnKcHqJ5WPUGywBefvUUTn4Iz83k3wPfbAAtkb6sUkwnxDi8E5LYYIG9dqpK00jhlEsxll" : "pk_test_51Kw3QQFHklCQeNE2UB78FF0zONs3TtVbz7mu8wzi3UcpjDjEPWfEXk3li2TgtpVBvwDULHu3mrWDb6R8AccaSu8p00xA56Tcen");

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
